import { Switch } from '@headlessui/react';
import clsx from 'clsx';

import useSupportPushMute from '@/renderer/utils/useSupportPushMute';

/**
 * Settings mirror of the Support Chat header mute toggle (#1439). Staff/admin
 * only. Muting silences this staffer's own inbound support-chat push (e.g. while
 * OOO); they still see messages in-app and the quiet-hours + morning digest are
 * unchanged. The switch is "on" when push is ENABLED (muted = off).
 */
export default function SupportPushMuteSwitch() {
  const { muted, setMuted, loading } = useSupportPushMute();
  const enabled = !muted;

  return (
    <div className="flex items-start space-x-4">
      <Switch
        checked={enabled}
        onChange={(next: boolean) => {
          void setMuted(!next);
        }}
        className={clsx(
          enabled ? 'bg-emerald-500 dark:bg-emerald-400' : 'bg-zinc-200 dark:bg-zinc-700',
          'relative inline-flex h-6 w-11 shrink-0 items-center rounded-full',
          loading && 'animate-pulse',
        )}
        disabled={loading}
      >
        <span className="sr-only">Support-chat push notifications</span>
        <span
          className={`${
            enabled ? 'translate-x-6' : 'translate-x-1'
          } inline-block size-4 rounded-full bg-white transition`}
        />
      </Switch>
      <div className="flex flex-col space-y-2">
        <div className="text-sm text-zinc-500 dark:text-zinc-400">
          {enabled
            ? 'On — you get a push when a member writes into support chat.'
            : 'Muted — no support-chat push to your phone (e.g. while OOO). You still see messages in the support view.'}
        </div>
      </div>
    </div>
  );
}
